export default __webpack_public_path__ + "static/media/blob 3.db4e8cfb.png";